import ko from '@tko/build.knockout';
import viewModel from './modal.vm';
import templateMarkup from 'raw-loader!./modal.template.html';
    
    // this component is directly registered at 'src/app/component-registration.js'
    // since it is needed long before its parent module is loaded
    export default { template: templateMarkup, viewModel: viewModel };

